// extracted by mini-css-extract-plugin
export default {"background":"styles_background__rrAya","wrapper":"styles_wrapper__Nqr74","image":"styles_image__4pi8F","title":"styles_title__kPk36","description":"styles_description__sekJz"};